export const setMemorizedStateToSessionStorage = (memorizedState: any) => {
  sessionStorage.setItem('memorizedState', JSON.stringify(memorizedState))
}

export const getMemorizedStateFromSessionStorage = () => {
  const memorizedState = sessionStorage.getItem('memorizedState')
  if (memorizedState) {
    return JSON.parse(memorizedState)
  }
  return null
}

export const clearMemorizedStateFromSessionStorage = () => {
  sessionStorage.removeItem('memorizedState')
}
